<template>
  <div class='roles'>
    <div class="table-row header">
      <div class="name">Name</div>
      <div class="description">Description</div>
      <div class="view-all-time-entries">View All<br/>Time Entries</div>
      <div class="edit-all-time-entries">Edit All<br/>Time Entries</div>
      <div class="view-financials">View<br/>Financials</div>
      <div class="view-all-tasks">View<br/>All Tasks</div>
      <div class="is-enabled">Disabled</div>
      <div class="buttons">
        <el-tooltip placement="top" content="Add Role" >
          <button class="mini primary" @click="addRole"><font-awesome-icon icon='plus' /></button>
        </el-tooltip>
      </div>
    </div>

    <RecycleScroller :items="roles" :item-height="30" class="roles-table">
      <div slot-scope="{ item }" class="table-row" @click="editRole(item, $event)">
        <div class="name">{{item.attributes.name}}</div>
        <div class="description">{{item.attributes.description}}</div>
        <div class="view-all-time-entries">{{item.attributes.viewAllTimeEntries}}</div>
        <div class="edit-all-time-entries">{{item.attributes.editAllTimeEntries}}</div>
        <div class="view-financials">{{item.attributes.viewFinancials}}</div>
        <div class="view-all-tasks">{{item.attributes.viewAllTasks}}</div>
        <div class="is-enabled">{{item.attributes.isEnabled}}</div>
        <div class="buttons"></div>
      </div>
    </RecycleScroller>
    <el-dialog :visible.sync="roleDialogIsVisible" class="role-dialog" width="500px" top="50px" :title="roleDialogTitle" :close-on-click-modal="false" v-draggable>
      <RoleDialog :role="selectedRole" :save="saveRole" :close="closeRoleDialog"></RoleDialog>
    </el-dialog>
  </div>
</template>

<script>

import RoleDialog from '@/components/RoleDialog'

export default {
  components: {
    RoleDialog
  },
  data () {
    return {
      roleDialogIsVisible: false,
      selectedRole: null,
      roleDialogMode: 'edit'
    }
  },
  computed: {
    roles () {
      return this.$store.getters['flux-roles/all'].sort((a, b) => {
        let aValue = a.attributes.name.toLowerCase()
        let bValue = b.attributes.name.toLowerCase()
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0
      })
    },
    roleDialogTitle () {
      return this.roleDialogMode === 'edit' ? 'Edit Role' : 'Add Role'
    }
  },
  methods: {
    addRole () {
      this.roleDialogIsVisible = true
      this.roleDialogMode = 'add'
    },
    editRole (role, event) {
      if (event.detail > 1) {
        return
      }

      this.roleDialogIsVisible = true
      this.roleDialogMode = 'add'
      this.selectedRole = role
    },
    saveRole (role) {
      if (!role.id) {
        this.$store.dispatch('flux-roles/create', role)
      } else {
        this.$store.dispatch('flux-roles/update', role).then(() => { this.$store.dispatch('flux-roles/loadById', { id: role.id }) })
      }
    },
    closeRoleDialog () {
      this.roleDialogIsVisible = false
    }
  }
}
</script>

<style lang='scss' >
@import '../styles/common.scss';

.roles {
  height: 100%;
  box-sizing: border-box;
  padding: 20px !important;

  .vue-recycle-scroller__item-view {
    width: initial !important;
    height: 31px;
    right: 0px;
  }
  .roles-table {
    height: calc(100vh - 290px);
    color: #606266;
  }
  .table-row {
    display: table;
    table-layout: fixed;
    border-bottom: 1px solid $table-border-color;
    height: 30px;
    width: 100%;

    > div {
      display: table-cell;
      white-space: nowrap;
      vertical-align: middle;
      padding-right: 5px;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-bottom: 5px;
    }
    &.header {
      font-weight: bold;
      color: gray;
      text-transform: uppercase;
      height: 25px;
      
      &:hover {
        background: none;
      }
      div {
        vertical-align: bottom;

        &:nth-child(n+3):not(:last-child) {
          text-align: center;
          width: 100px;
        }
      }
      .buttons {

        button {
          display: initial;
        }
      }
    }
    &:hover {
      background: $table-hover-color;
    }
    .name {
      width: 150px !important;
    }
    .description {
      width: 150px !important;
    }
    .view-all-time-entries {

    }
    .edit-all-time-entries {

    }
    .view-financials {

    }
    .view-all-tasks {

    }
    .is-enabled {

    }
    .buttons {
      width: 100%;
      text-align: right;

      button {
        width: 30px;
        height: 22px;
        display: none;
        padding: 2px 7px;
      }
    }
  }
}
</style>

